import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';

type Props = {
  days: number;
};

export function DaysWithHours({ days }: Props) {
  const semantic = useAtlasSemanticThemeTokens();
  const { t } = useTranslation();

  return (
    <Box>
      <Typography textAlign='left' lineHeight='20px'>
        {`${days} ${days === 1 ? t('dates.day') : t('dates.days')}`}
      </Typography>
      <Typography
        fontSize={12}
        textAlign='left'
        lineHeight='14px'
        color={semantic.color.text.muted}
      >
        {`${days * 24} ${t('dates.hours')}`}
      </Typography>
    </Box>
  );
}
